import { useEffect, useState } from "react";
import { AiOutlineExpand } from "react-icons/ai";
import { CiShoppingTag } from "react-icons/ci";
import {
  FaArrowRight,
  FaPhoneAlt,
  FaRegBuilding,
} from "react-icons/fa";
import { IoHomeOutline } from "react-icons/io5";
import { useParams } from "react-router-dom";
import projectImg from "../../../assets-user/projectImg.png";
import { MapEmbed } from "../../../components/admin/common/details-components";
import ContactOwnerModal from "../../../components/modals/ContactOwnerModal";
import ContactUs from "../../../components/public/userCommon/ContactUs";
import PropertyDetailsHeaderSection from "../../../components/public/userCommon/PropertyDetailsHeaderSection";
import PropertyDetailsMediaSection from "../../../components/public/userCommon/PropertyDetailsMediaSection";
import api from "../../../configs/api";
import useContactModal from "../../../hooks/useContactModal";
import { formatPrettyAddress, formatPrice } from "../../../utils/helpers";

const AboutProjects = () => {
  return (
    <div className="w-full pb-8">
      <div className="bg-white mx-auto p-4 sm:p-6 lg:p-8  rounded-lg border">
        {/* Header Section */}
        <div
          className="flex flex-row justify-between items-start sm:items-center gap-4 mb-6 sm:mb-8"
          data-aos="fade-up"
          data-aos-delay="100"
        >
          <h2 className="font-inter font-medium text-lg sm:text-xl md:text-2xl lg:text-3xl leading-[150%] tracking-[0.01em] text-[#222222] mb-1 sm:mb-2">
            About Project
          </h2>

          <button
            className="flex items-center gap-2 font-poppins font-medium text-sm sm:text-base md:text-lg leading-[150%] tracking-[0.01em] text-[#DC2200] text-center"
            data-aos="fade-left"
            data-aos-delay="200"
          >
            Explore Project
            <FaArrowRight className="text-xs sm:text-sm" />
          </button>
        </div>

        {/* Project Info Card */}
        <div className="rounded-3xl">
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:gap-6 lg:gap-8">
            {/* Project Logo Container */}
            <div
              className="flex-shrink-0 w-full sm:w-auto"
              data-aos="zoom-in"
              data-aos-delay="300"
            >
              <div className="w-32 sm:w-36  h-32 sm:h-36  bg-white rounded-3xl shadow-md flex items-center justify-center p-3 sm:p-4 mx-auto sm:mx-0">
                <img
                  src={projectImg}
                  alt="Covenants Developers Logo"
                  className="w-full h-full object-contain rounded-lg"
                />
              </div>
            </div>

            {/* Project Details */}
            <div
              className="flex-1 text-center sm:text-left w-full"
              data-aos="fade-right"
              data-aos-delay="400"
            >
              <h3 className="font-inter font-medium text-base sm:text-lg md:text-xl lg:text-[22px] leading-[150%] tracking-[0.01em] text-[#222222] mb-2">
                Covenants Developers
              </h3>
              <p className="font-inter font-normal text-sm sm:text-base md:text-lg lg:text-[18px] leading-[150%] tracking-[0.01em] text-[#98917F]">
                by Covenants
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
const CommercialPropertoesDetailsChart = ({ property, openModal }) => {
  if (!property) return null;

  // Extract required data safely
  const expectedPrice =
    property?.property?.allowedForConstructionDetails?.expectedPrice || 0;
  const pricePerSqft =
    property?.property?.allowedForConstructionDetails?.pricePerSqft || 0;
  const address = property?.location?.address?.formatted || "Not Available";
  const transactionType =
    property?.property?.transactionType || property?.transactionType || "N/A";
  const availability =
    property?.property?.allowedForConstructionDetails?.availability?.replaceAll(
      "_",
      " "
    ) || "N/A";

  return (
    <div className="py-6 md:py-8 lg:py-10">
      <div className="mx-auto bg-white rounded-lg p-4 sm:p-6 md:p-8 lg:p-10 w-full border">
        {/* Header */}
        <h2 className="font-inter font-medium tracking-[0.01em] leading-[150%] text-lg sm:text-xl md:text-2xl lg:text-3xl text-[#222222] mb-3">
          More Details
        </h2>

        {/* Property Details */}
        <div className="space-y-3 sm:space-y-4">
          {/* Price */}
          <div className="flex flex-col sm:flex-row sm:items-center font-inter text-gray-500">
            <div className="text-sm sm:text-base md:text-[1rem] lg:text-[1.1rem] sm:w-40 md:w-48">
              Price :
            </div>
            <div className="text-gray-900 text-sm sm:text-base md:text-[1rem] lg:text-[1.1rem] font-bold">
              {expectedPrice
                ? `${formatPrice(expectedPrice)} /`
                : "Price on Request"}{" "}
              <span className="text-xs sm:text-sm text-gray-500 font-normal ml-2">
                {pricePerSqft
                  ? `${formatPrice(pricePerSqft)} per sqft.`
                  : "N/A"}
              </span>
            </div>
          </div>

          {/* Address */}
          <div className="flex flex-col sm:flex-row sm:items-center font-inter text-gray-500">
            <div className="text-sm sm:text-base md:text-[1rem] lg:text-[1.1rem] sm:w-40 md:w-48">
              Address
            </div>
            <div className="text-[#222222] text-sm sm:text-base md:text-[1rem] lg:text-[1.1rem]">
              {address}
            </div>
          </div>

          {/* Transaction Type */}
          <div className="flex flex-col sm:flex-row sm:items-center font-inter text-gray-500">
            <div className="text-sm sm:text-base md:text-[1rem] lg:text-[1.1rem] sm:w-40 md:w-48">
              Transaction Type
            </div>
            <div className="text-[#222222] text-sm sm:text-base md:text-[1rem] lg:text-[1.1rem]">
              {transactionType}
            </div>
          </div>

          {/* Loading */}
          <div className="flex flex-col sm:flex-row sm:items-center font-inter text-gray-500">
            <div className="text-sm sm:text-base md:text-[1rem] lg:text-[1.1rem] sm:w-40 md:w-48">
              Loading
            </div>
            <div className="text-[#222222] text-sm sm:text-base md:text-[1rem] lg:text-[1.1rem]">
              20%
            </div>
          </div>

          {/* Availability */}
          <div className="flex flex-col sm:flex-row sm:items-center font-inter text-gray-500">
            <div className="text-sm sm:text-base md:text-[1rem] lg:text-[1.1rem] sm:w-40 md:w-48">
              Availability
            </div>
            <div className="text-[#222222] text-sm sm:text-base md:text-[1rem] lg:text-[1.1rem] capitalize">
              {availability}
            </div>
          </div>
        </div>

        {/* Contact Button */}
        <button
          onClick={() => openModal()}
          className="mt-6 sm:mt-8 bg-orange-500 hover:bg-orange-600 active:bg-orange-700 text-white font-semibold px-6 sm:px-8 py-2 sm:py-3 rounded-md transition-all duration-200 flex items-center gap-2 sm:gap-3 text-sm sm:text-base md:text-lg shadow-md hover:shadow-lg hover:scale-105"
        >
          <FaPhoneAlt className="text-sm sm:text-base md:text-lg" />
          Contact Owner
        </button>
      </div>
    </div>
  );
};

const CommercialPropertyDetailsCard = ({ property }) => {
  return (
    <div className="w-full mx-auto ">
      {/* Main Container */}
      <div className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm px-3 sm:px-4 md:px-6 lg:px-8 xl:px-10 py-4 sm:py-6 md:py-8">
        <PropertyDetailsHeaderSection
          displayTitle={property?.title}
          location={property?.location}
        />
        <PropertyDetailsMediaSection images={property?.images} />

        {/* Details Section */}
        <div className="">
          <div className="border border-gray-300 px-2 sm:px-5 py-2 sm:py-4 rounded-xl bg-gray-50">
            {/* Price */}
            <div className="mb-2 sm:mb-4 p-2 sm:p-4 rounded-lg flex flex-wrap items-center border-b border-gray-200 bg-white shadow-sm gap-2">
              <CiShoppingTag size={20} className="mr-2 sm:mr-3 flex-shrink-0" />
              <div className="min-w-[100px] flex-shrink-0">
                <p className="text-sm sm:text-lg md:text-xl lg:text-2xl font-bold text-gray-800 truncate">
                  {property?.property?.allowedForConstructionDetails
                    ?.expectedPrice
                    ? formatPrice(
                        property.property.allowedForConstructionDetails
                          .expectedPrice
                      )
                    : "N/A"}
                </p>
              </div>
              <div className="hidden sm:block h-6 sm:h-8 w-px bg-gray-300 mx-3"></div>
              <div className="flex-1 min-w-[100px]">
                <p className="text-xs sm:text-sm md:text-base text-gray-500 truncate">
                  Suitable For
                </p>
                <p className="font-semibold text-gray-800 text-xs sm:text-base truncate">
                  {property?.property?.suitableFor || "N/A"}
                </p>
              </div>
            </div>

            {/* Details Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-4 mb-2 sm:mb-4 p-2 sm:p-4 border-b border-gray-200 bg-white rounded-lg shadow-sm">
              <div className="flex items-center p-2 sm:p-3 rounded-lg hover:bg-gray-50 transition-colors truncate">
                <FaRegBuilding
                  size={20}
                  className="mr-2 sm:mr-3 flex-shrink-0"
                />
                <div className="truncate">
                  <p className="text-xs sm:text-sm text-gray-500">
                    Property Name
                  </p>
                  <p className="font-semibold text-gray-800 text-xs sm:text-base break-words truncate">
                    {property?.title || "N/A"}
                  </p>
                </div>
              </div>
              <div className="flex items-center p-2 sm:p-3 rounded-lg hover:bg-gray-50 transition-colors truncate">
                <IoHomeOutline
                  size={20}
                  className="mr-2 sm:mr-3 flex-shrink-0"
                />
                <div>
                  <p className="text-xs sm:text-sm text-gray-500">Floor</p>
                  <p className="font-semibold text-gray-800 text-xs sm:text-base truncate">
                    {property?.property?.allowedForConstructionDetails?.floor ||
                      "N/A"}
                  </p>
                </div>
              </div>
            </div>

            {/* Unit Configuration */}
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-4 p-2 sm:p-4 rounded-lg bg-white shadow-sm w-full overflow-x-auto">
              <AiOutlineExpand size={20} className="flex-shrink-0" />
              <div className="flex flex-wrap items-center gap-2 sm:gap-4 w-full min-w-[250px]">
                <div className="min-w-[70px] sm:min-w-[100px] truncate">
                  <p className="text-xs sm:text-sm text-gray-500 truncate">
                    Carpet Area
                  </p>
                  <p className="font-semibold text-gray-800 text-xs sm:text-base truncate">
                    {property?.property?.allowedForConstructionDetails
                      ?.carpetArea
                      ? (typeof property.property.allowedForConstructionDetails
                          .carpetArea === "object"
                          ? property.property.allowedForConstructionDetails
                              .carpetArea.value
                          : property.property.allowedForConstructionDetails
                              .carpetArea) + " sqft"
                      : "N/A"}
                  </p>
                </div>
                <div className="hidden sm:block h-6 w-px bg-gray-300"></div>
                <div className="min-w-[70px] sm:min-w-[100px] truncate">
                  <p className="text-xs sm:text-sm text-gray-500 truncate">
                    Super Area
                  </p>
                  <p className="font-semibold text-gray-800 text-xs sm:text-base truncate">
                    {property?.property?.allowedForConstructionDetails
                      ?.superArea
                      ? (typeof property.property.allowedForConstructionDetails
                          .superArea === "object"
                          ? property.property.allowedForConstructionDetails
                              .superArea.value
                          : property.property.allowedForConstructionDetails
                              .superArea) + " sqft"
                      : "N/A"}
                  </p>
                </div>
                <div className="hidden sm:block h-6 w-px bg-gray-300"></div>
                <div className="min-w-[70px] sm:min-w-[100px] truncate">
                  <p className="text-xs sm:text-sm text-gray-500 truncate">
                    Property Age
                  </p>
                  <p className="font-semibold text-gray-800 text-xs sm:text-base truncate">
                    {property?.propertyAge || property?.property?.propertyAge
                      ? `${
                          property?.propertyAge ||
                          property?.property?.propertyAge
                        } years`
                      : "N/A"}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const DetailsCommercialProperty = () => {
  const { id } = useParams();
  const { isOpen, openModal, closeModal } = useContactModal();
  const [property, setProperty] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCommercialProperty = async () => {
      try {
        setLoading(true);
        setError(null);

        const response = await api.get(`/properties/${id}`);

        // Check if the property type is commercial
        if (response.data.data.type !== "commercial") {
          setError("This property is not a commercial property");
          return;
        }

        setProperty(response.data.data);
      } catch (err) {
        console.error("Error fetching commercial property:", err);
        setError(
          err.response?.data?.message ||
            "Failed to fetch property details. Please try again."
        );
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchCommercialProperty();
    }
  }, [id]);

  // Loading state
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading property details...</p>
        </div>
      </div>
    );
  }

  // Error state
  if (error) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="text-red-500 text-xl mb-4">⚠️</div>
          <h2 className="text-xl font-semibold text-gray-800 mb-2">
            Error Loading Property
          </h2>
          <p className="text-gray-600">{error}</p>
          <button
            onClick={() => window.location.reload()}
            className="mt-4 px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  // No property found
  if (!property) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <p className="text-gray-600">No property found</p>
        </div>
      </div>
    );
  }

  return (
    <div className="overflow-hidden">
      <div className="grid grid-cols-1 lg:grid-cols-4 px-4 sm:px-6 lg:px-8 py-4 sm:py-6 lg:py-8  lg:gap-8">
        {/* left side */}
        <div className="col-span-3">
          <CommercialPropertyDetailsCard property={property} />
          <CommercialPropertoesDetailsChart
            property={property}
            openModal={openModal}
          />
          <AboutProjects property={property} />
          <MapEmbed
            className="h-[30rem]"
            coordinates={property?.location?.coordinates}
            address={formatPrettyAddress(property?.location)}
          />{" "}
        </div>

        {/* right side */}
        <div className="col-span-1 w-full mt-8 lg:mt-0">
          <ContactUs />
        </div>
      </div>
      <ContactOwnerModal
        isOpen={isOpen}
        onClose={closeModal}
        propertyData={property}
      />
    </div>
  );
};

export default DetailsCommercialProperty;

// import { useEffect, useState } from "react";
// import { AiOutlineExpand } from "react-icons/ai";
// import { CiShoppingTag } from "react-icons/ci";
// import {
//   FaArrowRight,
//   FaMapMarkerAlt,
//   FaPhoneAlt,
//   FaRegBuilding,
// } from "react-icons/fa";
// import { IoHomeOutline } from "react-icons/io5";
// import { useParams } from "react-router-dom";
// import projectImg from "../../../assets-user/projectImg.png";
// import ContactOwnerModal from "../../../components/modals/ContactOwnerModal";
// import ContactUs from "../../../components/public/userCommon/ContactUs";
// import api from "../../../configs/api";
// import useContactModal from "../../../hooks/useContactModal";
// import { formatPrettyAddress, formatPrice } from "../../../utils/helpers";
// import { MapEmbed } from "../../../components/admin/common/details-components";

// const AboutCommercialProjects = () => {
//   return (
//     <div className="w-full">
//       <div className="bg-white mx-auto p-4 sm:p-6 lg:p-8 xl:p-10 rounded-lg border">
//         {/* Header Section */}
//         <div
//           className="flex flex-row justify-between items-start sm:items-center gap-4 mb-6 sm:mb-8"
//           data-aos="fade-up"
//           data-aos-delay="100"
//         >
//           <h2 className="font-inter font-medium text-lg sm:text-xl md:text-2xl lg:text-3xl leading-[150%] tracking-[0.01em] text-[#222222] mb-1 sm:mb-2">
//             About Project
//           </h2>

//           <button
//             className="flex items-center gap-2 font-poppins font-medium text-sm sm:text-base md:text-lg leading-[150%] tracking-[0.01em] text-[#DC2200] text-center"
//             data-aos="fade-left"
//             data-aos-delay="200"
//           >
//             Explore Project
//             <FaArrowRight className="text-xs sm:text-sm" />
//           </button>
//         </div>

//         {/* Project Info Card */}
//         <div className="rounded-3xl">
//           <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:gap-6 lg:gap-8">
//             {/* Project Logo Container */}
//             <div
//               className="flex-shrink-0 w-full sm:w-auto"
//               data-aos="zoom-in"
//               data-aos-delay="300"
//             >
//               <div className="w-full sm:w-48 lg:w-56 xl:w-64 h-32 sm:h-36 lg:h-40 xl:h-44 bg-white rounded-3xl shadow-md flex items-center justify-center p-3 sm:p-4 mx-auto sm:mx-0">
//                 <img
//                   src={projectImg}
//                   alt="Covenants Developers Logo"
//                   className="w-full h-full object-contain rounded-lg"
//                 />
//               </div>
//             </div>

//             {/* Project Details */}
//             <div
//               className="flex-1 text-center sm:text-left w-full"
//               data-aos="fade-right"
//               data-aos-delay="400"
//             >
//               <h3 className="font-inter font-medium text-base sm:text-lg md:text-xl lg:text-[22px] leading-[150%] tracking-[0.01em] text-[#222222] mb-2">
//                 Covenants Developers
//               </h3>
//               <p className="font-inter font-normal text-sm sm:text-base md:text-lg lg:text-[18px] leading-[150%] tracking-[0.01em] text-[#98917F]">
//                 by Covenants
//               </p>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// const CommercialPropertoesDetailsChart = ({ property, openModal }) => {
//   if (!property) return null;

//   // Extract required data safely
//   const expectedPrice =
//     property?.property?.allowedForConstructionDetails?.expectedPrice || 0;
//   const pricePerSqft =
//     property?.property?.allowedForConstructionDetails?.pricePerSqft || 0;
//   const address = property?.location?.address?.formatted || "Not Available";
//   const transactionType =
//     property?.property?.transactionType || property?.transactionType || "N/A";
//   const availability =
//     property?.property?.allowedForConstructionDetails?.availability?.replaceAll(
//       "_",
//       " "
//     ) || "N/A";

//   return (
//     <div className="py-6 md:py-8 lg:py-10">
//       <div className="mx-auto bg-white rounded-lg p-4 sm:p-6 md:p-8 lg:p-10 w-full border">
//         {/* Header */}
//         <h2 className="font-inter font-medium tracking-[0.01em] leading-[150%] text-lg sm:text-xl md:text-2xl lg:text-3xl text-[#222222] mb-3">
//           More Details
//         </h2>

//         {/* Property Details */}
//         <div className="space-y-3 sm:space-y-4">
//           {/* Price */}
//           <div className="flex flex-col sm:flex-row sm:items-center font-inter text-gray-500">
//             <div className="text-sm sm:text-base md:text-[1rem] lg:text-[1.1rem] sm:w-40 md:w-48">
//               Price :
//             </div>
//             <div className="text-gray-900 text-sm sm:text-base md:text-[1rem] lg:text-[1.1rem] font-bold">
//               {expectedPrice
//                 ? `${formatPrice(expectedPrice)} /`
//                 : "Price on Request"}{" "}
//               <span className="text-xs sm:text-sm text-gray-500 font-normal ml-2">
//                 {pricePerSqft
//                   ? `${formatPrice(pricePerSqft)} per sqft.`
//                   : "N/A"}
//               </span>
//             </div>
//           </div>

//           {/* Address */}
//           <div className="flex flex-col sm:flex-row sm:items-center font-inter text-gray-500">
//             <div className="text-sm sm:text-base md:text-[1rem] lg:text-[1.1rem] sm:w-40 md:w-48">
//               Address
//             </div>
//             <div className="text-[#222222] text-sm sm:text-base md:text-[1rem] lg:text-[1.1rem]">
//               {address}
//             </div>
//           </div>

//           {/* Transaction Type */}
//           <div className="flex flex-col sm:flex-row sm:items-center font-inter text-gray-500">
//             <div className="text-sm sm:text-base md:text-[1rem] lg:text-[1.1rem] sm:w-40 md:w-48">
//               Transaction Type
//             </div>
//             <div className="text-[#222222] text-sm sm:text-base md:text-[1rem] lg:text-[1.1rem]">
//               {transactionType}
//             </div>
//           </div>

//           {/* Loading */}
//           <div className="flex flex-col sm:flex-row sm:items-center font-inter text-gray-500">
//             <div className="text-sm sm:text-base md:text-[1rem] lg:text-[1.1rem] sm:w-40 md:w-48">
//               Loading
//             </div>
//             <div className="text-[#222222] text-sm sm:text-base md:text-[1rem] lg:text-[1.1rem]">
//               20%
//             </div>
//           </div>

//           {/* Availability */}
//           <div className="flex flex-col sm:flex-row sm:items-center font-inter text-gray-500">
//             <div className="text-sm sm:text-base md:text-[1rem] lg:text-[1.1rem] sm:w-40 md:w-48">
//               Availability
//             </div>
//             <div className="text-[#222222] text-sm sm:text-base md:text-[1rem] lg:text-[1.1rem] capitalize">
//               {availability}
//             </div>
//           </div>
//         </div>

//         {/* Contact Button */}
//         <button
//           onClick={() => openModal()}
//           className="mt-6 sm:mt-8 bg-orange-500 hover:bg-orange-600 active:bg-orange-700 text-white font-semibold px-6 sm:px-8 py-2 sm:py-3 rounded-md transition-all duration-200 flex items-center gap-2 sm:gap-3 text-sm sm:text-base md:text-lg shadow-md hover:shadow-lg hover:scale-105"
//         >
//           <FaPhoneAlt className="text-sm sm:text-base md:text-lg" />
//           Contact Owner
//         </button>
//       </div>
//     </div>
//   );
// };

// const CommercialPropertyDetailsCard = ({ property }) => {
//   const [selectedImage, setSelectedImage] = useState(null);

//   const mainImage =
//     selectedImage ||
//     property?.images?.find((img) => img.isThumbnail)?.url ||
//     property?.images?.[0]?.url ||
//     "";

//   // Get 3 other images for thumbnails
//   const thumbnails =
//     property?.images
//       ?.filter((img) => img.url !== mainImage)
//       ?.slice(0, 3)
//       ?.map((img) => img.url) || [];

//   return (
//     <div className="w-full mx-auto">
//       {/* Main Container */}
//       <div className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm">
//         {/* Header */}
//         <div className="p-3 sm:p-4 md:p-6 pb-2">
//           <h2 className="font-medium text-[#031722] tracking-[0.01em] leading-[150%] text-xl sm:text-2xl md:text-3xl xl:text-[24px] mb-2 sm:mb-3 md:mb-4">
//             {property?.title || "N/A"}
//           </h2>
//           <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 flex-wrap">
//             <p className="font-normal text-[#8A8A8A] flex justify-between text-sm sm:text-base md:text-lg xl:text-[18px]">
//               {property?.location?.address?.formatted ||
//                 "Location not available"}
//               <span className="ml-3 text-blue-600 hover:text-blue-800 flex items-center cursor-pointer transition-colors">
//                 <FaMapMarkerAlt className="mr-1" /> See on Map
//               </span>
//             </p>
//           </div>
//         </div>

//         {/* Image Gallery */}
//         <div className="relative flex flex-col md:flex-row gap-2 sm:gap-4 md:gap-6 p-2 sm:p-4">
//           {/* Main Image */}
//           <div className="w-full md:w-[75%] bg-gray-200 rounded-xl overflow-hidden shadow-md flex items-center justify-center">
//             <img
//               src={mainImage}
//               alt={property?.title || "Property Image"}
//               className="w-full lg:h-[370px] object-cover hover:scale-105 transition-transform duration-500"
//             />
//           </div>

//           {/* Thumbnails */}
//           <div className="w-full mt-2 md:mt-0 md:w-[25%] flex md:flex-col flex-row md:justify-between justify-center gap-2 sm:gap-3 overflow-x-auto md:overflow-visible">
//             {thumbnails.map((url, i) => (
//               <div
//                 key={i}
//                 onClick={() => setSelectedImage(url)}
//                 className="min-w-[70px] sm:min-w-[90px] md:min-w-0 h-16 sm:h-20 md:h-24 lg:h-28 bg-gray-200 rounded-xl overflow-hidden shadow-md hover:shadow-lg transition-shadow cursor-pointer flex-shrink-0"
//               >
//                 <img
//                   src={url}
//                   alt={`Thumbnail ${i + 1}`}
//                   className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
//                 />
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* Details Section */}
//         <div className="p-2 sm:p-4 md:p-6 pt-2">
//           <div className="border border-gray-300 px-2 sm:px-5 py-2 sm:py-4 rounded-xl bg-gray-50">
//             {/* Price */}
//             <div className="mb-2 sm:mb-4 p-2 sm:p-4 rounded-lg flex flex-wrap items-center border-b border-gray-200 bg-white shadow-sm gap-2">
//               <CiShoppingTag size={20} className="mr-2 sm:mr-3 flex-shrink-0" />
//               <div className="min-w-[100px] flex-shrink-0">
//                 <p className="text-sm sm:text-lg md:text-xl lg:text-2xl font-bold text-gray-800 truncate">
//                   {property?.property?.allowedForConstructionDetails
//                     ?.expectedPrice
//                     ? formatPrice(
//                         property.property.allowedForConstructionDetails
//                           .expectedPrice
//                       )
//                     : "N/A"}
//                 </p>
//               </div>
//               <div className="hidden sm:block h-6 sm:h-8 w-px bg-gray-300 mx-3"></div>
//               <div className="flex-1 min-w-[100px]">
//                 <p className="text-xs sm:text-sm md:text-base text-gray-500 truncate">
//                   Suitable For
//                 </p>
//                 <p className="font-semibold text-gray-800 text-xs sm:text-base truncate">
//                   {property?.property?.suitableFor || "N/A"}
//                 </p>
//               </div>
//             </div>

//             {/* Details Grid */}
//             <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-4 mb-2 sm:mb-4 p-2 sm:p-4 border-b border-gray-200 bg-white rounded-lg shadow-sm">
//               <div className="flex items-center p-2 sm:p-3 rounded-lg hover:bg-gray-50 transition-colors truncate">
//                 <FaRegBuilding
//                   size={20}
//                   className="mr-2 sm:mr-3 flex-shrink-0"
//                 />
//                 <div className="truncate">
//                   <p className="text-xs sm:text-sm text-gray-500">
//                     Property Name
//                   </p>
//                   <p className="font-semibold text-gray-800 text-xs sm:text-base break-words truncate">
//                     {property?.title || "N/A"}
//                   </p>
//                 </div>
//               </div>
//               <div className="flex items-center p-2 sm:p-3 rounded-lg hover:bg-gray-50 transition-colors truncate">
//                 <IoHomeOutline
//                   size={20}
//                   className="mr-2 sm:mr-3 flex-shrink-0"
//                 />
//                 <div>
//                   <p className="text-xs sm:text-sm text-gray-500">Floor</p>
//                   <p className="font-semibold text-gray-800 text-xs sm:text-base truncate">
//                     {property?.property?.allowedForConstructionDetails?.floor ||
//                       "N/A"}
//                   </p>
//                 </div>
//               </div>
//             </div>

//             {/* Unit Configuration */}
//             <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-4 p-2 sm:p-4 rounded-lg bg-white shadow-sm w-full overflow-x-auto">
//               <AiOutlineExpand size={20} className="flex-shrink-0" />
//               <div className="flex flex-wrap items-center gap-2 sm:gap-4 w-full min-w-[250px]">
//                 <div className="min-w-[70px] sm:min-w-[100px] truncate">
//                   <p className="text-xs sm:text-sm text-gray-500 truncate">
//                     Carpet Area
//                   </p>
//                   <p className="font-semibold text-gray-800 text-xs sm:text-base truncate">
//                     {property?.property?.allowedForConstructionDetails
//                       ?.carpetArea
//                       ? (typeof property.property.allowedForConstructionDetails
//                           .carpetArea === "object"
//                           ? property.property.allowedForConstructionDetails
//                               .carpetArea.value
//                           : property.property.allowedForConstructionDetails
//                               .carpetArea) + " sqft"
//                       : "N/A"}
//                   </p>
//                 </div>
//                 <div className="hidden sm:block h-6 w-px bg-gray-300"></div>
//                 <div className="min-w-[70px] sm:min-w-[100px] truncate">
//                   <p className="text-xs sm:text-sm text-gray-500 truncate">
//                     Super Area
//                   </p>
//                   <p className="font-semibold text-gray-800 text-xs sm:text-base truncate">
//                     {property?.property?.allowedForConstructionDetails
//                       ?.superArea
//                       ? (typeof property.property.allowedForConstructionDetails
//                           .superArea === "object"
//                           ? property.property.allowedForConstructionDetails
//                               .superArea.value
//                           : property.property.allowedForConstructionDetails
//                               .superArea) + " sqft"
//                       : "N/A"}
//                   </p>
//                 </div>
//                 <div className="hidden sm:block h-6 w-px bg-gray-300"></div>
//                 <div className="min-w-[70px] sm:min-w-[100px] truncate">
//                   <p className="text-xs sm:text-sm text-gray-500 truncate">
//                     Property Age
//                   </p>
//                   <p className="font-semibold text-gray-800 text-xs sm:text-base truncate">
//                     {property?.propertyAge || property?.property?.propertyAge
//                       ? `${
//                           property?.propertyAge ||
//                           property?.property?.propertyAge
//                         } years`
//                       : "N/A"}
//                   </p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };
// const DetailsCommercialProperty = () => {
//   const { id } = useParams();
//   const { isOpen, openModal, closeModal } = useContactModal();
//   const [property, setProperty] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const fetchCommercialProperty = async () => {
//       try {
//         setLoading(true);
//         setError(null);

//         const response = await api.get(`/properties/${id}`);

//         // Check if the property type is commercial
//         if (response.data.data.type !== "commercial") {
//           setError("This property is not a commercial property");
//           return;
//         }

//         setProperty(response.data.data);
//       } catch (err) {
//         console.error("Error fetching commercial property:", err);
//         setError(
//           err.response?.data?.message ||
//             "Failed to fetch property details. Please try again."
//         );
//       } finally {
//         setLoading(false);
//       }
//     };

//     if (id) {
//       fetchCommercialProperty();
//     }
//   }, [id]);

//   // Loading state
//   if (loading) {
//     return (
//       <div className="flex items-center justify-center min-h-screen">
//         <div className="text-center">
//           <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
//           <p className="mt-4 text-gray-600">Loading property details...</p>
//         </div>
//       </div>
//     );
//   }

//   // Error state
//   if (error) {
//     return (
//       <div className="flex items-center justify-center min-h-screen">
//         <div className="text-center">
//           <div className="text-red-500 text-xl mb-4">⚠️</div>
//           <h2 className="text-xl font-semibold text-gray-800 mb-2">
//             Error Loading Property
//           </h2>
//           <p className="text-gray-600">{error}</p>
//           <button
//             onClick={() => window.location.reload()}
//             className="mt-4 px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
//           >
//             Retry
//           </button>
//         </div>
//       </div>
//     );
//   }

//   // No property found
//   if (!property) {
//     return (
//       <div className="flex items-center justify-center min-h-screen">
//         <div className="text-center">
//           <p className="text-gray-600">No property found</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="overflow-hidden">
//       <div className="grid grid-cols-1 lg:grid-cols-4 px-4 sm:px-6 lg:px-8 xl:px-10 py-4 sm:py-6 lg:py-8 xl:py-10 lg:gap-10">
//         {/* left side */}
//         <div className="col-span-3">
//           <CommercialPropertyDetailsCard property={property} />
//           <CommercialPropertoesDetailsChart
//             property={property}
//             openModal={openModal}
//           />
//           <AboutCommercialProjects property={property} />
//           <div className="mt-4 sm:mt-6 md:mt-8 lg:mt-10">
//           <MapEmbed
//             className="h-[30rem]"
//             coordinates={property?.location?.coordinates}
//             address={formatPrettyAddress(property?.location)}
//           />{" "}
//           </div>
//         </div>

//         {/* right side */}
//         <div className="lg:col-span-1 flex flex-col">
//           <ContactUs />
//         </div>
//       </div>
//       <ContactOwnerModal
//         isOpen={isOpen}
//         onClose={closeModal}
//         propertyData={property}
//       />
//     </div>
//   );
// };

// export default DetailsCommercialProperty;
